import { Box, Flex, Group, Image, NumberFormatter, Table, Text } from '@mantine/core';
import { dataRows } from './data';
export const GameTableRow = dataRows.map(row => <Table.Tr key={row.id}>
    <Table.Td visibleFrom="lg">
      <Group wrap="nowrap">
        <Image src={row.rankAvatar} alt="avatar" w={40} h={40} />
        <Text fz="xs" fw={700} tt="uppercase">
          {row.level}
        </Text>
      </Group>
    </Table.Td>
    <Table.Td>
      <Group wrap="nowrap">
        <Image src={row.playerAvatar} alt="user-avatar" />
        <Text fz="xs">{row.playerName}</Text>
      </Group>
    </Table.Td>
    <Table.Td visibleFrom="sm">
      <Text fz="xs">{row.date}</Text>
    </Table.Td>
    <Table.Td>
      <NumberFormatter prefix="$" value={row.wager} />
    </Table.Td>
    <Table.Td visibleFrom="sm">
      <NumberFormatter suffix="X" value={row.multiplier} />
    </Table.Td>
    <Table.Td miw={{
    base: 60,
    sm: 150
  }}>
      <Flex justify={{
      base: 'end',
      sm: 'start'
    }}>
        <Box w={{
        base: 55,
        sm: 70,
        md: '100%'
      }}>
          <Text fz="xs" fw={700} c={row.payout > 0 ? 'var(--text-green)' : 'var(--text-red)'} ta={{
          base: 'right',
          sm: 'left'
        }} truncate="end">
            <NumberFormatter prefix="$" decimalSeparator="." thousandSeparator="," decimalScale={2} fixedDecimalScale value={row.payout} />
          </Text>
        </Box>
      </Flex>
    </Table.Td>
  </Table.Tr>);